import { debounce } from '../../utils/debounce'
import { SidebarButton } from '../../components/sidebar/sidebar-button'
import { $el } from 'src/scripts/utils/utils'

const FOOTER_SELECTOR = '.shopify-section-footer'
const PRODUCTS_SELECTOR = '#ShopProducts'
const THRESHOLD_FOR_EXTEND = 24

export class SidebarFiltersStickyMobileButton extends SidebarButton {
  prevScrollY: number

  mountComponent(): void {
    super.mountComponent()
    this.addListener(window, 'scroll', this.handleWindowScroll)
  }

  handleWindowScroll = (): void => {
    if (!this.prevScrollY) {
      this.prevScrollY = window.scrollY
    }

    this.updateVisibleStatus()
    this.updateExtendStatus()
  }

  updateVisibleStatus(): void {
    const products = $el(PRODUCTS_SELECTOR)
    const footer = $el(FOOTER_SELECTOR)

    const rect = products?.getBoundingClientRect()
    const footerOffsetTop = footer ? footer.offsetTop : 0
    const isUnderFooter = window.innerHeight + window.scrollY < footerOffsetTop
    const isUnderProduct = rect.top < 0
    const isVisible = isUnderFooter && isUnderProduct

    this.toggleAttribute('is-visible', isVisible)
    document.body.toggleAttribute('is-filters-button-fixed', isVisible)
  }

  updateExtendStatus = debounce((): void => {
    const distance = Math.abs(window.scrollY - this.prevScrollY)

    if (distance > THRESHOLD_FOR_EXTEND) {
      this.toggleAttribute('is-extended', this.prevScrollY > window.scrollY)
    }

    this.prevScrollY = 0
  }, 50)
}
